<ng-container>
  <span style="display: block; margin-top: 30px">{{ 'MODAL_CERTIFICATIONS.ACCOUNT.STATEMENT' | translate }}</span>

  <form [formGroup]="certificateForm">
    <mat-card class="mat-elevation-z0 b-0-5 my-16">
      <mat-card-content>
        <mat-radio-group formControlName="certificateType">
          <ng-container *ngFor="let option of certificateOptions; let i = index">
            <mat-radio-button
              [value]="option.value"
              [labelPosition]="'before'"
              [disabled]="isOptionDisabled(option)"
              color="primary"
              class="row items-center justify-between py-10"
              [ngClass]="i !== certificateOptions.length - 1 ? 'bb-0-5' : ''">
              <div class="flex-col-container">
                <span [innerHTML]="option.title | translate" class="fw-700 fs-14"></span>
                <span [innerHTML]="option.description | translate" class="fs-12 lh-1"></span>
              </div>
            </mat-radio-button>
          </ng-container>
        </mat-radio-group>
      </mat-card-content>
    </mat-card>

    <div *ngIf="showYearField" @fadeInOut>
      <span class="fw-400 fs-14">{{ 'MODAL_CERTIFICATIONS.ACCOUNT.SELECT_YEAR' | translate }}</span>
      <mat-card class="mat-elevation-z0 b-0-5 my-16">
        <mat-form-field class="w-all">
          <mat-label>{{ 'MODAL_CERTIFICATIONS.ACCOUNT.YEAR_PLACEHOLDER' | translate }}</mat-label>
          <mat-select formControlName="year">
            <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card>
    </div>
  </form>
</ng-container>
